export default "__VITE_ASSET__79f12017__"